import Storage from "./localStorage";
import { setJQueryHtmlSafely } from "./module/sanitizeHtml";

const wp = wp_metis;
const storage = new Storage();

const alpineData = () => {
  return {
    courses: [],

    loadMerklisteCourses: async function () {

      const result = jQuery.ajax({
        type: "post",
        url: ajaxurl,
        data: {
          action: "merkliste_courses",
          data: {
            guestListID: storage.getGuestMerklisteKey(),
          },
        },
        success: function (response) {
          // console.log("Ajax Image Response:", response);
          setJQueryHtmlSafely(jQuery('#course-result-container'), response);
          document.dispatchEvent(new CustomEvent("courses-loaded-ajax"));
        },
        error: function (error) {
          console.log("Error", error);
          return false;
        },
      });
    },
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.pageMerkliste = alpineData;
